var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.internalValue && _vm.internalValue.length <= 0)?_c('div',{staticClass:"no-results"},[_c('div',[_c('p',[_vm._v("Aucun résultat")]),_vm._v(" "),_c('button',{on:{"click":_vm.clear}},[_c('span',[_vm._v("Supprimer les filtres")])])]),_vm._v(" "),_c('figure')]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b1e5f81","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoResults.vue
// module id = 899
// module chunks = 0